import { useState } from 'react';

import useResize from 'core/hooks/browser/useResize';

const ONE_REM = 600;
const calcFontSize = (width: number) => width / ONE_REM + 'rem';

export const CSS_VAR_KEY = '--wc-font-size';

// TODO: Remove it.
export default function useDynamicFontSize(
  container: HTMLElement | TNil,
  name: string
) {
  const defWidth = prevWidthCache.get(name) ?? 0;
  const [fontSize, setFontSize] = useState(calcFontSize(defWidth));

  useResize(container, () => {
    if (!container) return;

    setFontSize(calcFontSize(container.offsetWidth));

    if (container.offsetWidth > 0) {
      prevWidthCache.set(name, container.offsetWidth);
    }
  });

  const style = { [CSS_VAR_KEY]: fontSize } as React.CSSProperties;

  return { style };
}

// From the assumption that size of the window is basically static we can make
// one visual optimization. Instead of calculating the font-size twice (initial
// container-less render + the 2nd container-ful render), we can reuse the
// previous width for the 1st render to avoid UX blinking.
const prevWidthCache = new Map<string, number>();
